import MapScreen from "./screens/MapScreen";

export default function App() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <MapScreen />
    </div>
  );
}
